// import React, { useState, useMemo, useEffect } from "react";
// import {
//   Users,
//   MapPin,
//   Download,
//   User,
//   UserCheck,
//   Sun,
//   Moon,
// } from "lucide-react";
// import Layout from "../../components/layout/Layout";
// import MainHeading from "../../components/common/MainHeading";
// import CommonFilter, {
//   type IFilter,
// } from "../../components/common/CommonFilter";
// import CommonTable, {
//   type TableColumn,
// } from "../../components/common/CommonTable";
// import TablePagination from "../../components/common/TablePagination";
// import type { IPageInfo } from "@/interface/common.interface";

// // ─── Mock Data ──────────────────────────────────────────────────────────

// const mockLabour = [
//   {
//     id: "#L001",
//     name: "Ramesh Kumar",
//     gender: "Male",
//     mobile: "9876543210",
//     altMobile: "9876543211",
//     site: "Site 4 – Roofing",
//     shift: "Day",
//     aadhar: "1234-5678-9012",
//   },
//   {
//     id: "#L002",
//     name: "Sunita Devi",
//     gender: "Female",
//     mobile: "9876543212",
//     altMobile: "",
//     site: "Site 2 – Block A",
//     shift: "Night",
//     aadhar: "2345-6789-0123",
//   },
//   {
//     id: "#L003",
//     name: "Arvind Yadav",
//     gender: "Male",
//     mobile: "9876543213",
//     altMobile: "9876543214",
//     site: "Site 1 – Foundation",
//     shift: "Day",
//     aadhar: "3456-7890-1234",
//   },
//   {
//     id: "#L004",
//     name: "Priya Sharma",
//     gender: "Female",
//     mobile: "9876543215",
//     altMobile: "",
//     site: "Site 3 – Interior",
//     shift: "Night",
//     aadhar: "4567-8901-2345",
//   },
//   {
//     id: "#L005",
//     name: "Vikram Singh",
//     gender: "Male",
//     mobile: "9876543216",
//     altMobile: "9876543217",
//     site: "Site 4 – Roofing",
//     shift: "Day",
//     aadhar: "5678-9012-3456",
//   },
//   {
//     id: "#L006",
//     name: "Anita Patel",
//     gender: "Female",
//     mobile: "9876543218",
//     altMobile: "",
//     site: "Site 2 – Block A",
//     shift: "Day",
//     aadhar: "6789-0123-4567",
//   },
// ];

// // ─── Filter / Sort options ─────────────────────────────────────────────

// const sortOptions = [
//   { label: "Name", value: "name" },
//   { label: "ID", value: "id" },
//   { label: "Site", value: "site" },
//   { label: "Gender", value: "gender" },
//   { label: "Shift", value: "shift" },
// ];

// // ─── Component ──────────────────────────────────────────────────────────

// const LabourReport: React.FC = () => {
//   const [filter, setFilter] = useState<IFilter>({
//     search: "",
//     sort: "name",
//     site: "All",
//     shift: "All",
//     gender: "All",
//   });

//   const [pagination, setPagination] = useState<IPageInfo>({
//     currentPage: 1,
//     pageSize: 5,
//     total: mockLabour.length,
//     totalPages: Math.ceil(mockLabour.length / 5),
//   });

//   // ─── Filter logic ──────────────────────────────────────────────────

//   const filteredData = useMemo(() => {
//     const search = (filter.search || "").toLowerCase().trim();
//     const siteFilter = filter.site || "All";
//     const shiftFilter = filter.shift || "All";
//     const genderFilter = filter.gender || "All";

//     return mockLabour.filter((item) => {
//       const matchesSearch =
//         !search ||
//         item.name.toLowerCase().includes(search) ||
//         item.id.toLowerCase().includes(search) ||
//         item.aadhar.replace(/-/g, "").includes(search.replace(/-/g, "")) ||
//         item.mobile.includes(search);

//       const matchesSite = siteFilter === "All" || item.site === siteFilter;
//       const matchesShift = shiftFilter === "All" || item.shift === shiftFilter;
//       const matchesGender =
//         genderFilter === "All" || item.gender === genderFilter;

//       return matchesSearch && matchesSite && matchesShift && matchesGender;
//     });
//   }, [filter.search, filter.site, filter.shift, filter.gender]);

//   // ─── Sync pagination ──────────────────────────────────────────────

//   useEffect(() => {
//     const total = filteredData.length;
//     const totalPages = Math.ceil(total / pagination.pageSize) || 1;
//     setPagination((prev) => ({
//       ...prev,
//       total,
//       totalPages,
//       currentPage: prev.currentPage > totalPages ? 1 : prev.currentPage,
//     }));
//   }, [filteredData.length, pagination.pageSize]);

//   // ─── Paginated data ────────────────────────────────────────────────

//   const paginatedData = useMemo(() => {
//     const start = (pagination.currentPage - 1) * pagination.pageSize;
//     return filteredData.slice(start, start + pagination.pageSize);
//   }, [filteredData, pagination.currentPage, pagination.pageSize]);

//   // ─── Stats ──────────────────────────────────────────────────────────

//   const stats = useMemo(
//     () => ({
//       total: mockLabour.length,
//       sites: new Set(mockLabour.map((l) => l.site)).size,
//       male: mockLabour.filter((l) => l.gender === "Male").length,
//       female: mockLabour.filter((l) => l.gender === "Female").length,
//     }),
//     [],
//   );

//   // ─── Handlers ──────────────────────────────────────────────────────

//   const handleSearchChange = (value: string) => {
//     setFilter((prev) => ({ ...prev, search: value }));
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleFilterChange = (value: string, name: string) => {
//     setFilter((prev) => ({ ...prev, [name]: value }));
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleChangePageSize = (size: number) => {
//     const totalPages = Math.ceil(filteredData.length / size) || 1;
//     setPagination({
//       ...pagination,
//       pageSize: size,
//       currentPage: 1,
//       totalPages,
//     });
//   };

//   const handleResetFilters = () => {
//     setFilter({
//       search: "",
//       sort: "name",
//       site: "All",
//       shift: "All",
//       gender: "All",
//     });
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   // ─── Export CSV ──────────────────────────────────────────────────────

//   const handleExportCSV = () => {
//     const headers = [
//       "ID",
//       "Full Name",
//       "Gender",
//       "Mobile",
//       "Assigned Site",
//       "Shift",
//       "Aadhar Number",
//     ];
//     const rows = filteredData.map((l) => [
//       l.id,
//       l.name,
//       l.gender,
//       l.mobile,
//       l.site,
//       l.shift,
//       l.aadhar,
//     ]);
//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [
//         headers.join(","),
//         ...rows.map((r) => r.map((v) => `"${v}"`).join(",")),
//       ].join("\n");
//     const link = document.createElement("a");
//     link.setAttribute("href", encodeURI(csvContent));
//     link.setAttribute(
//       "download",
//       `Labour_Report_${new Date().toISOString().split("T")[0]}.csv`,
//     );
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // ─── Table Columns ──────────────────────────────────────────────────

//   const columns: TableColumn<(typeof mockLabour)[0]>[] = [
//     {
//       key: "id",
//       header: "ID",
//       render: (item) => (
//         <span className="font-mono font-bold text-slate-700 bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-xs">
//           {item.id}
//         </span>
//       ),
//     },
//     {
//       key: "name",
//       header: "Full Name",
//       render: (item) => {
//         const initials = item.name
//           .split(" ")
//           .map((n) => n[0])
//           .join("")
//           .substring(0, 2)
//           .toUpperCase();
//         const isMale = item.gender === "Male";
//         return (
//           <div className="flex items-center gap-3">
//             <div
//               className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs shadow-sm ${
//                 isMale
//                   ? "bg-blue-100 text-blue-700 border border-blue-200"
//                   : "bg-rose-100 text-rose-700 border border-rose-200"
//               }`}
//             >
//               {initials}
//             </div>
//             <div>
//               <p className="font-semibold text-slate-900 text-sm leading-tight">
//                 {item.name}
//               </p>
//               <p className="text-xs text-slate-400">Labour</p>
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       key: "gender",
//       header: "Gender",
//       render: (item) => {
//         const isMale = item.gender === "Male";
//         return (
//           <span
//             className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide border ${
//               isMale
//                 ? "bg-blue-50 text-blue-700 border-blue-100"
//                 : "bg-rose-50 text-rose-700 border-rose-100"
//             }`}
//           >
//             <span
//               className={`w-1.5 h-1.5 rounded-full mr-1.5 ${isMale ? "bg-blue-500" : "bg-rose-500"}`}
//             />
//             {item.gender}
//           </span>
//         );
//       },
//     },
//     {
//       key: "mobile",
//       header: "Mobile Number",
//       render: (item) => (
//         <span className="text-sm font-medium text-slate-600 block">
//           {item.mobile}
//         </span>
//       ),
//     },
//     {
//       key: "site",
//       header: "Assigned Site",
//       render: (item) => (
//         <div className="flex items-center gap-1.5 text-slate-600">
//           <MapPin size={14} className="text-emerald-500 shrink-0" />
//           <span className="text-sm font-medium">{item.site}</span>
//         </div>
//       ),
//     },
//     {
//       key: "shift",
//       header: "Shift",
//       render: (item) => {
//         const isDay = item.shift === "Day";
//         return (
//           <span
//             className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${
//               isDay
//                 ? "bg-amber-50 text-amber-700 border-amber-200"
//                 : "bg-indigo-50 text-indigo-700 border-indigo-200"
//             }`}
//           >
//             {isDay ? (
//               <Sun size={12} className="text-amber-500" />
//             ) : (
//               <Moon size={12} className="text-indigo-500" />
//             )}
//             {item.shift}
//           </span>
//         );
//       },
//     },
//     {
//       key: "aadhar",
//       header: "Aadhar Number",
//       render: (item) => (
//         <span className="font-mono text-xs text-slate-500 font-medium tracking-wider">
//           {item.aadhar}
//         </span>
//       ),
//     },
//   ];

//   // ─── Additional Filters (Site, Shift, Gender) ──────────────────────

//   const siteOptions = [
//     { label: "All Sites", value: "All" },
//     ...Array.from(new Set(mockLabour.map((l) => l.site))).map((site) => ({
//       label: site,
//       value: site,
//     })),
//   ];

//   const shiftOptions = [
//     { label: "All Shifts", value: "All" },
//     ...Array.from(new Set(mockLabour.map((l) => l.shift))).map((shift) => ({
//       label: shift === "Day" ? "Day Shift" : "Night Shift",
//       value: shift,
//     })),
//   ];

//   const genderOptions = [
//     { label: "All Genders", value: "All" },
//     { label: "Male", value: "Male" },
//     { label: "Female", value: "Female" },
//   ];

//   const additionalFilters = (
//     <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
//       <div className="flex items-center gap-1">
//         <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">
//           Site:
//         </label>
//         <select
//           value={filter.site || "All"}
//           onChange={(e) => handleFilterChange(e.target.value, "site")}
//           className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
//         >
//           {siteOptions.map((opt) => (
//             <option key={opt.value} value={opt.value}>
//               {opt.label}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="flex items-center gap-1">
//         <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">
//           Shift:
//         </label>
//         <select
//           value={filter.shift || "All"}
//           onChange={(e) => handleFilterChange(e.target.value, "shift")}
//           className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
//         >
//           {shiftOptions.map((opt) => (
//             <option key={opt.value} value={opt.value}>
//               {opt.label}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="flex items-center gap-1">
//         <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">
//           Gender:
//         </label>
//         <select
//           value={filter.gender || "All"}
//           onChange={(e) => handleFilterChange(e.target.value, "gender")}
//           className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
//         >
//           {genderOptions.map((opt) => (
//             <option key={opt.value} value={opt.value}>
//               {opt.label}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );

//   // ─── Render ──────────────────────────────────────────────────────────

//   return (
//     <div className="space-y-6 max-w-7xl mx-auto p-4 md:p-6">
//       {/* Header with MainHeading and actions */}
//       <div className="border-b border-slate-100 pb-5">
//         <MainHeading
//           title="Labour Report Dashboard"
//           actions={
//             <button
//               onClick={handleExportCSV}
//               disabled={filteredData.length === 0}
//               className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:pointer-events-none rounded-xl shadow-sm transition-all duration-200"
//             >
//               <Download size={16} />
//               Export 
//             </button>
//           }
//         />
//       </div>


//       {/* Filter + Table */}
//       <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
//         <CommonFilter
//           searchValue={filter.search || ""}
//           onSearchChange={handleSearchChange}
//           searchPlaceholder="Search by ID, Name, Mobile, Aadhar..."
//           value={filter}
//           onChange={handleFilterChange}
//           filterOptions={[]}
//           sortOptions={sortOptions}
//           sortName="sort"
//           sortPlaceholder="Sort by: Name"
//           additionalFilters={additionalFilters}
//         />
//         <div className="flex justify-between items-center mt-1">
//           <span className="text-xs text-slate-400">
//             {filteredData.length} record{filteredData.length !== 1 ? "s" : ""}{" "}
//             found
//           </span>
//           {(filter.search ||
//             filter.site !== "All" ||
//             filter.shift !== "All" ||
//             filter.gender !== "All") && (
//             <button
//               onClick={handleResetFilters}
//               className="text-xs font-semibold text-rose-600 hover:bg-rose-50 px-3 py-1 rounded-lg transition-colors"
//             >
//               Clear all filters
//             </button>
//           )}
//         </div>

//         <CommonTable
//           data={paginatedData}
//           columns={columns}
//           loading={false}
//           stickyColumns={2}
//         />
//         <TablePagination
//           paginationData={pagination}
//           setPaginationData={setPagination}
//           handleChangePageSize={handleChangePageSize}
//           isLoading={false}
//         />
//       </div>
//     </div>
//   );
// };

// export default LabourReport;


import React, { useState, useMemo, useEffect } from "react";
import { Download } from "lucide-react";
import Layout from "../../components/layout/Layout";
import MainHeading from "../../components/common/MainHeading";
import CommonFilter, { type IFilter } from "../../components/common/CommonFilter";
import CommonTable, { type TableColumn } from "../../components/common/CommonTable";
import TablePagination from "../../components/common/TablePagination";
import type { IPageInfo } from "@/interface/common.interface";
import { ShiftBadge, GenderBadge, SiteLabel, AvatarCell } from "../../components/common/Badge";

// ─── Mock Data ──────────────────────────────────────────────────────────

const mockLabour = [
  {
    id: "#L001",
    name: "Ramesh Kumar",
    gender: "Male",
    mobile: "9876543210",
    altMobile: "9876543211",
    site: "Site 4 – Roofing",
    shift: "Day",
    aadhar: "1234-5678-9012",
  },
  {
    id: "#L002",
    name: "Sunita Devi",
    gender: "Female",
    mobile: "9876543212",
    altMobile: "",
    site: "Site 2 – Block A",
    shift: "Night",
    aadhar: "2345-6789-0123",
  },
  {
    id: "#L003",
    name: "Arvind Yadav",
    gender: "Male",
    mobile: "9876543213",
    altMobile: "9876543214",
    site: "Site 1 – Foundation",
    shift: "Day",
    aadhar: "3456-7890-1234",
  },
  {
    id: "#L004",
    name: "Priya Sharma",
    gender: "Female",
    mobile: "9876543215",
    altMobile: "",
    site: "Site 3 – Interior",
    shift: "Night",
    aadhar: "4567-8901-2345",
  },
  {
    id: "#L005",
    name: "Vikram Singh",
    gender: "Male",
    mobile: "9876543216",
    altMobile: "9876543217",
    site: "Site 4 – Roofing",
    shift: "Day",
    aadhar: "5678-9012-3456",
  },
  {
    id: "#L006",
    name: "Anita Patel",
    gender: "Female",
    mobile: "9876543218",
    altMobile: "",
    site: "Site 2 – Block A",
    shift: "Day",
    aadhar: "6789-0123-4567",
  },
];

// ─── Filter / Sort options ─────────────────────────────────────────────

const sortOptions = [
  { label: "Name", value: "name" },
  { label: "ID", value: "id" },
  { label: "Site", value: "site" },
  { label: "Gender", value: "gender" },
  { label: "Shift", value: "shift" },
];

// ─── Component ──────────────────────────────────────────────────────────

const LabourReport: React.FC = () => {
  const [filter, setFilter] = useState<IFilter>({
    search: "",
    sort: "name",
    site: "All",
    shift: "All",
    gender: "All",
  });

  const [pagination, setPagination] = useState<IPageInfo>({
    currentPage: 1,
    pageSize: 5,
    total: mockLabour.length,
    totalPages: Math.ceil(mockLabour.length / 5),
  });

  // ─── Filter logic ──────────────────────────────────────────────────

  const filteredData = useMemo(() => {
    const search = (filter.search || "").toLowerCase().trim();
    const siteFilter = filter.site || "All";
    const shiftFilter = filter.shift || "All";
    const genderFilter = filter.gender || "All";

    return mockLabour.filter((item) => {
      const matchesSearch =
        !search ||
        item.name.toLowerCase().includes(search) ||
        item.id.toLowerCase().includes(search) ||
        item.aadhar.replace(/-/g, "").includes(search.replace(/-/g, "")) ||
        item.mobile.includes(search);

      const matchesSite = siteFilter === "All" || item.site === siteFilter;
      const matchesShift = shiftFilter === "All" || item.shift === shiftFilter;
      const matchesGender = genderFilter === "All" || item.gender === genderFilter;

      return matchesSearch && matchesSite && matchesShift && matchesGender;
    });
  }, [filter.search, filter.site, filter.shift, filter.gender]);

  // ─── Sync pagination ──────────────────────────────────────────────

  useEffect(() => {
    const total = filteredData.length;
    const totalPages = Math.ceil(total / pagination.pageSize) || 1;
    setPagination((prev) => ({
      ...prev,
      total,
      totalPages,
      currentPage: prev.currentPage > totalPages ? 1 : prev.currentPage,
    }));
  }, [filteredData.length, pagination.pageSize]);

  // ─── Paginated data ────────────────────────────────────────────────

  const paginatedData = useMemo(() => {
    const start = (pagination.currentPage - 1) * pagination.pageSize;
    return filteredData.slice(start, start + pagination.pageSize);
  }, [filteredData, pagination.currentPage, pagination.pageSize]);

  // ─── Handlers ──────────────────────────────────────────────────────

  const handleSearchChange = (value: string) => {
    setFilter((prev) => ({ ...prev, search: value }));
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleFilterChange = (value: string, name: string) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChangePageSize = (size: number) => {
    const totalPages = Math.ceil(filteredData.length / size) || 1;
    setPagination({
      ...pagination,
      pageSize: size,
      currentPage: 1,
      totalPages,
    });
  };

  const handleResetFilters = () => {
    setFilter({
      search: "",
      sort: "name",
      site: "All",
      shift: "All",
      gender: "All",
    });
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  // ─── Export CSV ──────────────────────────────────────────────────────

  const handleExportCSV = () => {
    const headers = ["ID", "Full Name", "Gender", "Mobile", "Assigned Site", "Shift", "Aadhar Number"];
    const rows = filteredData.map((l) => [l.id, l.name, l.gender, l.mobile, l.site, l.shift, l.aadhar]);
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.map((v) => `"${v}"`).join(","))].join("\n");
    const link = document.createElement("a");
    link.setAttribute("href", encodeURI(csvContent));
    link.setAttribute("download", `Labour_Report_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ─── Table Columns ──────────────────────────────────────────────────
  // ID / Name / Gender / Site / Shift all use the same shared Badge /
  // AvatarCell / SiteLabel components as the other report tables.

  const columns: TableColumn<(typeof mockLabour)[0]>[] = [
    {
      key: "id",
      header: "ID",
      render: (item) => (
        <span className="font-mono font-bold text-slate-700 bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-xs">
          {item.id}
        </span>
      ),
    },
    {
      key: "name",
      header: "Full Name",
      render: (item) => {
        const idx = parseInt(item.id.replace(/\D/g, ""), 10) || 0;
        return <AvatarCell name={item.name} subLabel="Labour" paletteIndex={idx} />;
      },
    },
    {
      key: "gender",
      header: "Gender",
      render: (item) => <GenderBadge gender={item.gender} />,
    },
    {
      key: "mobile",
      header: "Mobile Number",
      render: (item) => <span className="text-sm font-medium text-slate-600 block">{item.mobile}</span>,
    },
    {
      key: "site",
      header: "Assigned Site",
      render: (item) => <SiteLabel label={item.site} />,
    },
    {
      key: "shift",
      header: "Shift",
      render: (item) => <ShiftBadge shift={item.shift} />,
    },
    {
      key: "aadhar",
      header: "Aadhar Number",
      render: (item) => (
        <span className="font-mono text-xs text-slate-500 font-medium tracking-wider">{item.aadhar}</span>
      ),
    },
  ];

  // ─── Additional Filters (Site, Shift, Gender) ──────────────────────

  const siteOptions = [
    { label: "All Sites", value: "All" },
    ...Array.from(new Set(mockLabour.map((l) => l.site))).map((site) => ({
      label: site,
      value: site,
    })),
  ];

  const shiftOptions = [
    { label: "All Shifts", value: "All" },
    ...Array.from(new Set(mockLabour.map((l) => l.shift))).map((shift) => ({
      label: shift === "Day" ? "Day Shift" : "Night Shift",
      value: shift,
    })),
  ];

  const genderOptions = [
    { label: "All Genders", value: "All" },
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ];

  const additionalFilters = (
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
      <div className="flex items-center gap-1">
        <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Site:</label>
        <select
          value={filter.site || "All"}
          onChange={(e) => handleFilterChange(e.target.value, "site")}
          className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
        >
          {siteOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-1">
        <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Shift:</label>
        <select
          value={filter.shift || "All"}
          onChange={(e) => handleFilterChange(e.target.value, "shift")}
          className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
        >
          {shiftOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-1">
        <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Gender:</label>
        <select
          value={filter.gender || "All"}
          onChange={(e) => handleFilterChange(e.target.value, "gender")}
          className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
        >
          {genderOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>
  );

  // ─── Render ──────────────────────────────────────────────────────────

  return (
    <div className="space-y-6 max-w-7xl mx-auto p-4 md:p-6">
      <div className="border-b border-slate-100 pb-5">
        <MainHeading
          title="Labour Report Dashboard"
          actions={
            <button
              onClick={handleExportCSV}
              disabled={filteredData.length === 0}
              className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:pointer-events-none rounded-xl shadow-sm transition-all duration-200"
            >
              <Download size={16} />
              Export
            </button>
          }
        />
      </div>

      <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
        <CommonFilter
          searchValue={filter.search || ""}
          onSearchChange={handleSearchChange}
          searchPlaceholder="Search by ID, Name, Mobile, Aadhar..."
          value={filter}
          onChange={handleFilterChange}
          filterOptions={[]}
          sortOptions={sortOptions}
          sortName="sort"
          sortPlaceholder="Sort by: Name"
          additionalFilters={additionalFilters}
        />
        <div className="flex justify-between items-center mt-1">
          <span className="text-xs text-slate-400">
            {filteredData.length} record{filteredData.length !== 1 ? "s" : ""} found
          </span>
          {(filter.search || filter.site !== "All" || filter.shift !== "All" || filter.gender !== "All") && (
            <button
              onClick={handleResetFilters}
              className="text-xs font-semibold text-rose-600 hover:bg-rose-50 px-3 py-1 rounded-lg transition-colors"
            >
              Clear all filters
            </button>
          )}
        </div>

        <CommonTable data={paginatedData} columns={columns} loading={false} stickyColumns={2} />
        <TablePagination
          paginationData={pagination}
          setPaginationData={setPagination}
          handleChangePageSize={handleChangePageSize}
          isLoading={false}
        />
      </div>
    </div>
  );
};

export default LabourReport;